import { render } from "./StadtratView.vue?vue&type=template&id=78422286&scoped=true"
import script from "./StadtratView.vue?vue&type=script&lang=js"
export * from "./StadtratView.vue?vue&type=script&lang=js"

import "./StadtratView.vue?vue&type=style&index=0&id=78422286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78422286"]])

export default __exports__